import './App.css';
import  Square  from './components/Square';
import { useEffect, useState } from 'react';
import styled from 'styled-components';


const initialGameState = ["","","","","","","","",""];
function App() {

  const [gameState,setGameState] = useState(initialGameState);
  const [activePlayer,setActivePlayer] = useState("X");
  const [winner,setWinner] = useState("");

  useEffect(() => {

    checkWinner(gameState);

  },[gameState])

  const onClickHandler = (id)=>{
    const isClickable = gameState[id] === "" ? true : false; 

    if(isClickable)
      {
        let copyGameState = [...gameState];
        copyGameState[id] = activePlayer;
        setGameState(copyGameState);
        const newPlayer = activePlayer === "X" ? "O" : "X";
        setActivePlayer(newPlayer);

      }


  }

  const restartGame = () => {
    setGameState(initialGameState);
    setActivePlayer("X");
    setWinner("");
  }

  const checkWinner = (gameState) => {

    const winningConditions = [
      [0,1,2],
      [3,4,5],
      [6,7,8],
      [0,3,6],
      [1,4,7],
      [2,5,8],
      [0,4,8],
      [2,4,6],
    ]

    winningConditions.forEach((winningCondition) => {

      const[a,b,c] = winningCondition ;

      const isEqual = gameState[a] === gameState[b] && gameState[b] === gameState[c];

      if(gameState[a]!=="" && isEqual){

        console.log("Winner ->" ,gameState[a]);
        setWinner(gameState[a]);

      }

    })

    if(winner === "" && gameState.find((element) => element === "") !== "" )
      setWinner("Both");


  }

  const renderWinner = () =>{

    if(winner === "Both")
      return <div className='result'>Draw</div>;
    else
      return <div className='result'>{`${winner} wins`}</div>;
    

  }

  

  return (
    <Container>
      <LeftWrapper>
          <h1>Lets Play Tic-Tac-Toe Game!</h1>
          <button onClick={restartGame}>Start New Game</button>
      </LeftWrapper>
      <RightWrapper>
        <Players activePlayer={activePlayer}>
          <div className="player-X">Player X</div>
          <div className="player-O">Player O</div>
        </Players>
        <GameBoard>
          {winner ? renderWinner() :
            gameState.map((letter,index) => {

            return <Square key={index} id={index} letter={letter} onClickHandler= {onClickHandler} />

          }) }
        </GameBoard>
      </RightWrapper>
    </Container>
  );
}


const Container = styled.div`

  width: 100vw;
  height: 100vh;
  display: flex;
  padding: 100px;
  background-color: black;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;

`

const LeftWrapper = styled.div`

  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  h1{
    font-size: 4rem;
    font-weight:bolder;
    color:#E2EBEF ;
    margin-right: 80px;
  }

  button{

    margin-top: 100px;
    width: 240px;
    height: 60px;
    border-radius: 40px;
    font-size: 18px;
    background-color: #E2EBEF ;
    color:black;
    cursor: pointer;
  }

`

const RightWrapper = styled.div`

  width: 50%;
  padding: 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;


`
const activePlayerStyle = (activePlayer) =>{

  if(activePlayer === "X")
    return `.player-X {
      color: #E2EBEF;
      border-bottom: 4px solid #E2EBEF;
      opacity:1;
    }` 

  else
    return `.player-O {
      color: #E2EBEF;
      border-bottom: 4px solid #E2EBEF; 
      opacity:1;
    }`

}


const Players = styled.div`

  display: flex;
  flex-direction: row;
  margin-bottom: 20px;

  div{

    width: 150px;
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 10px;
    color: #9a9a9a;
    border-bottom: 4px solid #9a9a9a;
    opacity: 0.5;

  }

 
  ${(props) => activePlayerStyle(props.activePlayer)}

`






const GameBoard = styled.div`

  width: 300px;
  height: 300px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  .result{

    font-size: 2rem;
    font-weight: bold;
    color: #E2EBEF;

  }


`

export default App;
